import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '../common/icons'
import { ErrorBoundary } from '../../helpers/errorBoundary';
import Aux from '../hoc/auxiliary'
import ReactPlayer from "react-player/lazy";
import { VideoInfo } from './videoInfo';
import { SpinnerPage } from '../hoc/spinnerPage';

export const ProductVideo = ({
  resource,
  getUrlWithSas,
  urlWithSas,
  loadingUrlWithSas,
  clearUrlWithSas,
  insideProduct,

}) => {

  
    const ref = useRef()

    const [ videoInformation, setVideoInformation ] = useState(false)



    useEffect(() => {


            const resourceInt = parseInt(resource.id.split('_')[1],10)
    
            // getUrlWithSas(23389)
          getUrlWithSas(resourceInt)
      
  
        // return () => {

        //     clearUrlWithSas();
        //   };
  
      }, [])

    //   useEffect(() =>{

    //     getToken()

    // }, [])



    const getToken = () => {

        // const apiBaseUrl = `${config.apiUrl}CognitiveSearch/GetVideoIndexerAccessToken`;
        //   axios
        //   .get(apiBaseUrl, {
        //     headers: authHeader(),
        //   })
        //   .then(function (response) {
        //     console.log('response', response)
        //     getVideoInformation(response.data)
        //   })
        //   .catch(function (error) {
        //     console.log(
        //       "Looks like there was a problem: \n",
        //       error.response.data
        //     );

        //   });
    }

    const getVideoInformation = async (token) => {

        // setVideoInformation(false)
        // console.log("videoId", resource.videoId)
        //   axios
        //   .get(`https://api.videoindexer.ai/uksouth/Accounts/3f5b838f-9bf8-4647-a4ed-9c680eff5e36/Videos/${resource.videoId}/Index`, {
        //     headers: {'Authorization': 'Bearer ' + token},
        //   })
        //   .then(function (response) {
        //     console.log('response', response)
        //     setVideoInformation(response.data)
        //   })
        //   .catch(function (error) {
        //     console.log(
        //       "Looks like there was a problem: \n",
        //       error.response.data
        //     );
        //     //component.setState({ printingmessage: error.response.data })
        //   });
        // //   const searchResults = await handleResponse(res)

    }

    const seekTo = secs => {

        ref.current.seekTo(secs, 'seconds')
    }
   

    
    
    //lets make this a switch

    console.log("urlWithSas", urlWithSas)

    return(

        <Aux>
            
  
       
                <div className="gpt-message__product--video">
                       


                                <SpinnerPage loading={loadingUrlWithSas}>

                                    <div style={{width: '100%'}}>

                                 

                                    {urlWithSas

                                        ?

                                        <div
                                        className={'react-player__preview-wrapper'}
                                        onClick={(event) => event.stopPropagation()}
                                        >
                                        <ErrorBoundary>
                                            <ReactPlayer
                                            ref={ref}
                                            url={urlWithSas.url}
                                            className="react-player"
                                            width="100%"
                                            height="100%"
                                            controls={true}
                                            playing={true}
                                            />
                                        </ErrorBoundary>
                                        </div>


                                        :

                                        <div></div>


                                    }

                                    </div>
                                </SpinnerPage>



                      
                </div>
                <div className="gpt-message__product--contents-info">
                    <div className="gpt-message__product--contents-info-top">
                    <div style={{display: 'flex', gap: '2rem'}}>
            <div className="subtitle-1 black">{resource.title}</div>
      
      </div>

            {videoInformation && <VideoInfo information={videoInformation} seekTo={seekTo} />}
    </div>

    {!insideProduct &&

    <div className="gpt-message__product--contents-options">
        <div>
          
        
        </div>
        <div className="gpt-message__product--contents-option">
                <Icon name="arrow-right" customClass="icon--normal" />
            </div>
    </div>
}
</div>
</Aux>
      
    )


}
